import CreateSale from '~/apps/pos/mobile/pages/CreateSale';
import SaleHistory from '~/apps/pos/mobile/pages/SaleHistory';
import SaleView from '~/apps/pos/mobile/pages/SaleView';
import SalePrintResult from '~/apps/pos/mobile/pages/SalePrintResult';
import SaleHelp from "~/apps/pos/mobile/pages/SaleHelp";
import DeleteSale from "~/apps/pos/mobile/pages/DeleteSale";
import { requireRole } from "~/apps/shared/permissions";
import { UserRole } from "~/apps/shared/consts";

export const appRoutes = [
  {
    name: 'mobile',
    path: '/mobile',
    forwardTo: 'pos.mobile.history',
    canActivate: requireRole(UserRole.CLERK),
    children: [
      {
        name: 'createSale',
        path: '/create',
        comp: CreateSale,
      },
      {
        name: 'editSale',
        path: '/edit/:saleId',
        comp: CreateSale,
      },
      {
        name: 'deleteSale',
        path: '/delete/:saleId',
        comp: DeleteSale,
      },
      {
        name: 'history',
        path: '/history?q&status',
        comp: SaleHistory,
      },
      {
        name: 'view',
        path: '/view/:saleId?q&status',
        comp: SaleView,
      },
      {
        name: 'printResult',
        path: '/printresult',
        comp: SalePrintResult,
      },
      {
        name: 'help',
        path: '/help',
        comp: SaleHelp,
      },
    ],
  },
];
